import { Component, Input, OnInit } from '@angular/core';
import * as chartData from '../../data/dashboard/default'
import { LocalizationDataService } from 'src/app/services/data/localization-data.service';

@Component({
  selector: 'app-budget-balance',
  templateUrl: './budget-balance.component.html',
  styleUrls: ['./budget-balance.component.scss']
})
export class BudgetBlanaceComponent implements OnInit {
  @Input() budget;
  @Input() tooltip: any;
  constructor(private localizationService: LocalizationDataService){}
  public totalBalance;
  public totalBudget;
  primaryColor = localStorage.getItem("primary_color") || "#7366ff";
  secondary_color = localStorage.getItem("secondary_color") || "#f73164";
  
  ngOnInit() {
    this.generateChartForTotalBudget();
  }
  generateChartForTotalBudget() {
    this.totalBudget = {
      series: [this.budget?.chart_data?.series?.total_budget],
      chart: {
        type: "bar",
        width: 180,
        height: 120,
        stacked: false,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          vertical: true,
          columnWidth: "40%",
          barHeight: "80%",
          startingShape: "rounded",
          endingShape: "rounded",
        },
      },
      colors: [this.primaryColor, this.primaryColor, "#F2F3F7", "#F2F3F7"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 0,
      },
      legend: {
        show: false,
      },
      grid: {
        xaxis: {
          offsetX: -2,
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      yaxis: {
        show: false,
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      tooltip: {
        shared: false,
        x: {
          show: false,
        },
        y: {
          show: false,
        },
        z: {
          show: false,
        },
      },
      xaxis: {
        categories: this.budget?.chart_data?.categories,
        offsetX: 0,
        offsetY: 0,
        labels: {
          offsetX: 0,
          offsetY: 0,
          show: false,
        },
        axisBorder: {
          offsetX: 0,
          offsetY: 0,
          show: false,
        },
        axisTicks: {
          offsetX: 0,
          offsetY: 0,
          show: false,
        },
      },
      responsive: [
        {
          breakpoint: 1760,
          options: {
            chart: {
              width: 160,
            },
          },
        },
        {
          breakpoint: 1601,
          options: {
            chart: {
              height: 110,
            },
          },
        },
        {
          breakpoint: 1560,
          options: {
            chart: {
              width: 140,
            },
          },
        },
        {
          breakpoint: 1460,
          options: {
            chart: {
              width: 120,
            },
          },
        },
        {
          breakpoint: 1400,
          options: {
            chart: {
              width: 290,
            },
          },
        },
        {
          breakpoint: 1110,
          options: {
            chart: {
              width: 200,
            },
          },
        },
        {
          breakpoint: 700,
          options: {
            chart: {
              width: 150,
            },
          },
        },
        {
          breakpoint: 576,
          options: {
            chart: {
              width: 220,
            },
          },
        },
        {
          breakpoint: 420,
          options: {
            chart: {
              width: 150,
            },
          },
        },
      ],
    };

    this.totalBalance = {
      series: [this.budget?.chart_data?.series?.remaining_budget],
      chart: {
        width: 200,
        height: 125,
        type: "line",
        toolbar: {
          show: false,
        },
        dropShadow: {
          enabled: true,
          enabledOnSeries: undefined,
          top: 5,
          left: 0,
          blur: 3,
          color: "#16C7F9",
          opacity: 0.3,
        },
        zoom: {
          enabled: false,
        },
      },
      colors: ["#16C7F9"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 2,
        curve: "smooth",
      },
      grid: {
        show: false,
      },
      tooltip: {
        x: {
          show: false,
        },
        y: {
          show: false,
        },
        z: {
          show: false,
        },
        marker: {
          show: false,
        },
      },
      xaxis: {
        categories: this.budget?.chart_data?.categories,
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      yaxis: {
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      responsive: [
        {
          breakpoint: 1780,
          options: {
            chart: {
              width: 180,
            },
          },
        },
        {
          breakpoint: 1680,
          options: {
            chart: {
              width: 160,
            },
          },
        },
        {
          breakpoint: 1601,
          options: {
            chart: {
              height: 110,
            },
          },
        },
        {
          breakpoint: 1560,
          options: {
            chart: {
              width: 140,
            },
          },
        },
        {
          breakpoint: 1460,
          options: {
            chart: {
              width: 120,
            },
          },
        },
        {
          breakpoint: 1400,
          options: {
            chart: {
              width: 290,
            },
          },
        },
        {
          breakpoint: 1110,
          options: {
            chart: {
              width: 200,
            },
          },
        },
        {
          breakpoint: 700,
          options: {
            chart: {
              width: 150,
            },
          },
        },
        {
          breakpoint: 576,
          options: {
            chart: {
              width: 220,
            },
          },
        },
        {
          breakpoint: 420,
          options: {
            chart: {
              width: 150,
            },
          },
        },
      ],
    };
  }

  get currency() {
    return this.localizationService.currency;
  }
}
